import React, { useCallback, useEffect, useMemo, useState } from "react";
import * as RB from "react-bootstrap";
import DataTable from "react-data-table-component";
import FilterComponent from "../FilterComponent";
import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
import { Delete } from "@mui/icons-material";
import * as utils from "../../Utils/comman";
import { useSelector } from "react-redux";
import {
  AddCircle,
  ArrowDown,
  Document,
  DocumentDownload,
  Edit,
  Edit2,
  Eye,
  Mobile,
  ProfileAdd,
  ShoppingCart,
  Trash,
} from "iconsax-react";
import moment from "moment/moment";
import { Link } from "react-router-dom";
import * as XLSX from "xlsx";
import CustomPagination from "../../Utils/CustomPagination";
import Select from "react-select";

function List(props) {
  const [venderList, setVenderList] = useState([]);
  const [page, setPage] = useState(1);
  const countPerPage = 10;
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions
  );
  const [showModal, setShowModal] = useState(false);
  const [contactInfo, setContactInfo] = useState([]);

  const [categoryList, setCategoryList] = useState([]);
  const [units, setUnits] = useState([]);

  const [category, setCategory] = useState("");
  const [createdBy, setCreatedBy] = useState("");
  const [vendorId, setvendorId] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [contactPersion, setContactPersion] = useState("");
  const [contact, setContact] = useState("");
  const [gst_no, setGst_no] = useState("");
  const [filter, setFilter] = useState(false);
  const [states, setStates] = useState([]);
  const [state, setstate] = useState("");
  const [dealItem, setDealItem] = useState("");
  const [materialLIst, setMaterialLIst] = useState([]);

  useEffect(() => {
    getState();
    getMateriallist();
  }, []);

  const getState = () => {
    utils
      .callAPI("get", `/state/list`)
      .then((res) => {
        if (Array.isArray(res)) {
          setStates(res);
        } else {
          setStates([]);
        }
      })
      .catch((err) => {
        setStates([]);
      });
  };

  const getMateriallist = () => {
    utils
      .callAPI("get", `/rawmaterial/list`)
      .then((res) => {
        if (typeof res !== "undefined") {
          setMaterialLIst(res?.result);
        } else {
          setMaterialLIst([]);
        }
      })
      .catch((err) => {
        setMaterialLIst([]);
      });
  };

  const handleAddClick = (e) => {
    const propdata = {
      mode: "add",
    };
    props.onChange(propdata);
  };
  const columns = [
    {
      name: "Sr.No",
      selector: (row, index) => index + 1,
      width: "68px",
    },
    {
      name: (
        <div>
          Vendor Id <br />
        </div>
      ),
      selector: (row) => row.vendorId,
      width: "100px",
    },
    {
      name: (
        <div>
          Date Created <br />
        </div>
      ),
      selector: (row) => moment(row.createdAt).format("DD-MM-YYYY"),
    },
    {
      name: (
        <div>
          Created By <br />
        </div>
      ),
      selector: (row) => row.created_name,
    },
    {
      name: (
        <div>
          Company Name <br />
        </div>
      ),
      selector: (row) => row?.companyName,
    },
    {
      name: (
        <div>
          Contact Person <br />
        </div>
      ),
      selector: (row) => row.name,
    },
    {
      name: "Contact",
      selector: (row) => row.contactNo,
    },
    {
      name: (
        <div>
          Deal Item <br />
        </div>
      ),
      selector: (row) => (
        <RB.OverlayTrigger
          trigger="click"
          rootClose
          key="bottom"
          placement="bottom"
          overlay={
            <RB.Popover id={`popover-product-list`}>
              <RB.Popover.Body className="p-0">
                <ul className="list-group">
                  {row.product_name.map((product, index) => (
                    <li key={product.id} className="list-group-item">
                      {product.product_name}
                    </li>
                  ))}
                </ul>
              </RB.Popover.Body>
            </RB.Popover>
          }
        >
          <RB.Button className="btn-flat">
            <Eye />
          </RB.Button>
        </RB.OverlayTrigger>
      ),
    },
    {
      name: "Status",
      selector: (row) => (row.status == "1" ? "Active" : "inActive"),
    },
    {
      name: "Action",
      center: true,
      cell: (row) => (
        <>
          <RB.Button
            className="btn-flat me-1"
            title="Contact & Bank Info"
            onClick={handleContact(row)}
          >
            <Mobile />
          </RB.Button>
          {utils.hasPermission(primaryMenuRes, "Vendor", "vendor.edit") && (
            <RB.Button
              className="btn-flat"
              title="Edit"
              onClick={handelEdit(row)}
            >
              <Edit2 />
            </RB.Button>
          )}
          {utils.hasPermission(primaryMenuRes, "Vendor", "vendor.delete") && (
            <RB.Button
              className="btn-flat ms-1"
              title="Delete"
              onClick={showDelete(row)}
            >
              <Trash />
            </RB.Button>
          )}
        </>
      ),
    },
  ];

  const handleAssignPermission = useCallback((row) => async () => {
    const propdata = {
      mode: "permission",
      rowData: row,
    };
    props.onChange(propdata);
  });

  useEffect(() => {
    getVenderList();
  }, [page, filterText, filter]);

  const getVenderList = () => {
    utils
      .callAPI(
        "get",
        `vendors/listAll?page=${page}&per_page=${countPerPage}&created_by=${createdBy}&company_name=${companyName}&name=${contactPersion}&contact_no=${contact}&gst_no=${gst_no}&state=${state}&deal_item=${dealItem}&vendor_id=${vendorId}`
      )
      .then((res) => {
        if (typeof res !== "undefined") {
          setVenderList(res);
          // setFilter(false)
        } else {
          setVenderList([]);
        }
      })
      .catch((err) => {
        setVenderList([]);
      });
  };

  const handelEdit = useCallback((row) => async () => {
    const propdata = {
      mode: "edit",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const handleContact = useCallback((row) => async () => {
    setContactInfo(row); // Set contact info state
    setShowModal(true); // Show the modal
  });

  const showDelete = useCallback((row) => async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        utils
          .callAPI("get", `/vendors/delete?vendorId=${row.id}`, "")
          .then((res) => {
            if (typeof res !== "undefined") {
              getVenderList();
            }
          })
          .catch((err) => {});
      }
    });
  });

  const subHeaderComponent = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <FilterComponent
        onFilter={(e) => setFilterText(e.target.value)}
        onClear={handleClear}
        filterText={filterText}
      />
    );
  }, [filterText, resetPaginationToggle]);

  const handleCloseModal = () => setShowModal(false);

  const handleSearch = () => {
    setFilter(true);
  };

  const handleReset = () => {
    setCreatedBy("");
    setCompanyName("");
    setContactPersion("");
    setContact("");
    setGst_no("");
    setstate("");
    setDealItem("");
    setvendorId("");
    setFilter(false);
  };

  const handleDownload = () => {
    utils
      .callAPI(
        "get",
        `/vendors/export-vendor?created_by=${createdBy}&company_name=${companyName}&name=${contactPersion}&contact_no=${contact}&gst_no=${gst_no}&state=${state}&deal_item=${dealItem}&vendor_id=${vendorId}`
      )
      .then((res) => {
        if (typeof res !== "undefined") {
          generateCSV(res);
        } else {
        }
      })
      .catch((err) => {});
  };

  function generateCSV(filteredData) {
    const ws = XLSX.utils.json_to_sheet(filteredData, {
      header: Object.keys(filteredData[0]),
      skipHeader: true,
    });

    const wb = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(wb, ws, "Vendor");

    const csvOutput = XLSX.utils.sheet_to_csv(ws);

    const blob = new Blob([csvOutput], { type: "text/csv;charset=utf-8;" });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "vendor_list.csv";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const stateOptions =
    states?.map((state) => ({
      value: state.state_code,
      label: state.state_name,
    })) || [];

  const dealItemOptions =
    materialLIst
      ?.filter((material) => material.status === "1")
      .map((mat) => ({
        value: mat.id,
        label: `${mat.product_name} (${mat.name})`,
      })) || [];

  return (
    <>
      <div className="section-body">
        <RB.Card className="card shadow ">
          <div className="floating-btns-holder-artisan">
            <a
              href
              className="btn btn-primary btn-circle me-2"
              variant="primary"
              onClick={() => handleDownload()}
            >
              <DocumentDownload />
            </a>

            {utils.hasPermission(primaryMenuRes, "Vendor", "vendor.create") && (
              <a
                href
                className="btn btn-dark btn-circle"
                variant="dark"
                onClick={handleAddClick}
              >
                <AddCircle />
              </a>
            )}
          </div>
          <RB.Card.Header>
            <h4></h4>
            <div className="card-header-action"></div>
          </RB.Card.Header>
          <RB.Card.Body>
            {utils.hasPermission(primaryMenuRes, "Vendor", "vendor.view") && (
              <>
                <RB.Row className="mb-2 g-2">
                  {/* Row 1 - 5 filters */}
                  <RB.Col md={2}>
                    <RB.Form.Control
                      type="text"
                      placeholder="Vendor Id"
                      value={vendorId}
                      onChange={(e) => {
                        setvendorId(e.target.value);
                        setFilter(false);
                      }}
                    />
                  </RB.Col>
                  <RB.Col md={2}>
                    <RB.Form.Control
                      type="text"
                      placeholder="Created By"
                      value={createdBy}
                      onChange={(e) => {
                        setCreatedBy(e.target.value);
                        setFilter(false);
                      }}
                    />
                  </RB.Col>
                  <RB.Col md={2}>
                    <RB.Form.Control
                      type="text"
                      placeholder="Company Name"
                      value={companyName}
                      onChange={(e) => {
                        setCompanyName(e.target.value);
                        setFilter(false);
                      }}
                    />
                  </RB.Col>
                  <RB.Col md={3}>
                    <RB.Form.Control
                      type="text"
                      placeholder="Contact Person"
                      value={contactPersion}
                      onChange={(e) => {
                        setContactPersion(e.target.value);
                        setFilter(false);
                      }}
                    />
                  </RB.Col>
                  <RB.Col md={3}>
                    <RB.Form.Control
                      type="text"
                      placeholder="Contact"
                      value={contact}
                      onChange={(e) => {
                        setContact(e.target.value);
                        setFilter(false);
                      }}
                    />
                  </RB.Col>
                </RB.Row>

                <RB.Row className="mb-3 g-2">
                  {/* Row 2 - Remaining filters + Search/Reset */}
                  <RB.Col md={2}>
                    <RB.Form.Control
                      type="text"
                      placeholder="GST No."
                      value={gst_no}
                      onChange={(e) => {
                        setGst_no(e.target.value);
                        setFilter(false);
                      }}
                    />
                  </RB.Col>
                  <RB.Col md={3}>
                    <Select
                      options={stateOptions}
                      value={
                        stateOptions.find((opt) => opt.value === state) || null
                      }
                      onChange={(selectedOption) => {
                        setstate(selectedOption ? selectedOption.value : "");
                        setFilter(false);
                      }}
                      placeholder="Select State"
                      isClearable
                    />
                  </RB.Col>
                  <RB.Col md={4}>
                    <Select
                      options={dealItemOptions}
                      value={
                        dealItemOptions.find((opt) => opt.value === dealItem) ||
                        null
                      }
                      onChange={(selectedOption) => {
                        setDealItem(selectedOption ? selectedOption.value : "");
                        setFilter(false);
                      }}
                      placeholder="Select Deal Item.."
                      isClearable
                    />
                  </RB.Col>
                  <RB.Col md={1} className="d-flex">
                    <RB.Button
                      variant="primary"
                      className="me-1 flex-fill"
                      onClick={handleSearch}
                    >
                      Search
                    </RB.Button>
                  </RB.Col>
                  <RB.Col md={1} className="d-flex">
                    <RB.Button
                      variant="secondary"
                      className="flex-fill"
                      onClick={handleReset}
                    >
                      Reset
                    </RB.Button>
                  </RB.Col>
                </RB.Row>

                <DataTable
                  columns={columns}
                  data={venderList.result}
                  highlightOnHover
                  responsive
                  pagination
                  paginationServer
                  paginationTotalRows={venderList.total}
                  paginationPerPage={countPerPage}
                  paginationComponentOptions={{
                    noRowsPerPage: true,
                  }}
                  paginationComponent={() => (
                    <CustomPagination
                      currentPage={page}
                      totalRows={venderList.total}
                      rowsPerPage={countPerPage}
                      onPageChange={handlePageChange}
                    />
                  )}
                  striped
                  onChangePage={(page) => setPage(page)}
                  persistTableHead
                  customStyles={{
                    head: {
                      style: {
                        fontSize: "0.875rem", // Adjust the font size as needed
                        fontWeight: "bold", // Adjust the font weight as needed
                      },
                    },
                  }}
                  // subHeader
                  // subHeaderComponent={subHeaderComponent}
                />
              </>
            )}
          </RB.Card.Body>
        </RB.Card>
      </div>

      <RB.Modal show={showModal} onHide={handleCloseModal} size="xl">
        <RB.Modal.Header closeButton>
          <RB.Modal.Title>Vendor Information</RB.Modal.Title>
        </RB.Modal.Header>
        <RB.Modal.Body>
          {contactInfo.contact_info?.length > 0 ? (
            <>
              <h5 className="mb-3">Contact Information</h5>
              <RB.Table striped bordered hover responsive>
                <thead>
                  <tr>
                    <th>GST No</th>
                    <th>Contact No</th>
                    <th>Address Type</th>
                    <th>Address</th>
                    <th>State</th>
                    <th>District</th>
                    <th>City</th>
                    <th>Pincode</th>
                  </tr>
                </thead>
                <tbody>
                  {contactInfo.contact_info.map((info) => (
                    <tr key={info.id}>
                      <td>{info.gstNo}</td>
                      <td>{info.mobileNo}</td>
                      <td>{info.addressType}</td>
                      <td>{info.address}</td>
                      <td>{info.state_name}</td>
                      <td>{info.district_name}</td>
                      <td>{info.city_name}</td>
                      <td>{info.pincode}</td>
                    </tr>
                  ))}
                </tbody>
              </RB.Table>

              <h5 className="mt-4">Bank Details</h5>
              <RB.Table bordered responsive className="table-sm">
                <tbody>
                  <tr>
                    <th>Account Name</th>
                    <td>{contactInfo.bankAccountName}</td>
                  </tr>
                  <tr>
                    <th>Account Number</th>
                    <td>{contactInfo.bankAccountNumber}</td>
                  </tr>
                  <tr>
                    <th>Bank Name</th>
                    <td>{contactInfo.bankName}</td>
                  </tr>
                  <tr>
                    <th>IFSC Code</th>
                    <td>{contactInfo.ifscCode}</td>
                  </tr>
                  <tr>
                    <th>Branch</th>
                    <td>{contactInfo.branch}</td>
                  </tr>
                  <tr>
                    <th>GST Verified</th>
                    <td>{contactInfo.gstVerify === "1" ? "Yes" : "No"}</td>
                  </tr>
                </tbody>
              </RB.Table>

              {contactInfo.cheque_images?.length !== 0 && (
                <>
                  <h5 className="mt-4">Cheque Images</h5>
                  <div className="d-flex flex-wrap gap-3">
                    {contactInfo.cheque_images?.map((img) => {
                      const isPDF = img.chequeImg
                        ?.toLowerCase()
                        .endsWith(".pdf");
                      return (
                        <div
                          key={img.imgId}
                          className="border rounded d-flex flex-column align-items-center justify-content-center text-center p-2 cursor-pointer"
                          onClick={() => window.open(img.chequeImg, "_blank")}
                        >
                          <div
                            className="ratio ratio-1x1"
                            style={{ width: "120px", cursor: "pointer" }}
                          >
                            {isPDF ? (
                              <div className="d-flex flex-column justify-content-center align-items-center w-100 h-100">
                                <Document
                                  size="36"
                                  color="#D32F2F"
                                  variant="Bold"
                                />
                                <small className="text-muted">PDF</small>
                              </div>
                            ) : (
                              <img
                                src={img.chequeImg}
                                alt="Cheque"
                                className="img-fluid w-100 h-100 object-fit-cover rounded"
                              />
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                    <p className="text-muted fst-italic mt-2">
                      *Note: Click on the image or PDF to view it in a new tab.
                    </p>
                </>
              )}
            </>
          ) : (
            <div>No contact information available.</div>
          )}
        </RB.Modal.Body>

        <RB.Modal.Footer>
          <RB.Button variant="secondary" onClick={handleCloseModal}>
            Close
          </RB.Button>
        </RB.Modal.Footer>
      </RB.Modal>
    </>
  );
}

export default List;
